module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/cooking/cutting-board-eed28e766c03d3786e997030bd2a8fca.svg";